import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { useLocation } from 'react-router-dom'

gsap.registerPlugin(ScrollTrigger)

export default function PageMotion() {
  const { pathname } = useLocation()

  useGSAP(
    () => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return
      }

      const elements = gsap.utils.toArray('[data-reveal]')

      elements.forEach((element, index) => {
        const direction = element.dataset.reveal
        const x = direction === 'left' ? -36 : direction === 'right' ? 36 : 0

        gsap.fromTo(
          element,
          { autoAlpha: 0, x, y: x ? 0 : 24 },
          {
            autoAlpha: 1,
            x: 0,
            y: 0,
            duration: 0.78,
            delay: Math.min(Number(element.dataset.revealDelay || 0), 0.35),
            ease: 'power3.out',
            scrollTrigger: {
              trigger: element,
              start: index < 2 ? 'top 96%' : 'top 88%',
              once: true,
            },
          },
        )
      })
    },
    { dependencies: [pathname], revertOnUpdate: true },
  )

  return null
}
